import { useMutation, useQueryClient } from '@tanstack/react-query'
import { generatePath, useHistory } from 'react-router-dom'
import { AxiosError } from 'axios'

import { AppRoute } from 'routing/AppRoute.enum'
import { Mutations } from 'api/mutations.enum'
import { Queries } from 'api/queries.enum'
import {
    DuplicatePulseSurveyFromTemplatePayload,
    DuplicatePulseSurveyFromTemplateResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { duplicatePulseSurveyFromTemplate } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

export const useDuplicatePulseSurveyFromTemplate = () => {
    const history = useHistory()

    const { onChangeActivePulseSurvey } = usePulseSurveys()

    const queryClient = useQueryClient()

    const mutation = useMutation<
        DuplicatePulseSurveyFromTemplateResponse,
        AxiosError,
        DuplicatePulseSurveyFromTemplatePayload
    >({
        mutationFn: duplicatePulseSurveyFromTemplate,
        mutationKey: [Mutations.duplicatePulseSurveyFromTemplate],
        onSuccess: async (pulseSurvey) => {
            await queryClient.invalidateQueries([Queries.getPulseSurveys])

            onChangeActivePulseSurvey(pulseSurvey)

            history.push(generateCompanyURI(generatePath(AppRoute.PulseSurveyCreate, { id: pulseSurvey.uuid })))
        },
    })

    return mutation
}
